import { Button, Card, Col, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap"
import { BsCalendar, BsClockFill } from "react-icons/bs"
import userDefault from '../img/userdefault.png'
import moment from 'moment'
import { FaEdit, FaInfoCircle, FaPen, FaRegClock, FaRegEye } from "react-icons/fa"
import Stars from '../components/Stars'
import { BiDollarCircle } from "react-icons/bi"
import { IoCloseCircle } from "react-icons/io5"
import { AiOutlineFolderView } from "react-icons/ai"
import { HiOutlineTrash } from "react-icons/hi"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import EnviarDocumentos from "./citas/EnviarDocumentos"
import { isAdminDoctor } from "../utils/isAdminDoctor"
import { isOperator } from "../utils/isOperator"
import DescargarDocumentos from "./citas/DescargarDocumentos"
import { useState } from "react"
import ModalChangeExpediente from "./modal/ModalChangeExpediente"
import EnviarLinkCita from "./citas/EnviarLinkCita"

function CardCitas({t, item, trash, imPaciente, auth, loadingDelete, deleteCita, showModelCancel, setShowModalCancel,objDelete,setObjDelete}) {    
   //console.log(item)
   const [expediente, setExpediente] = useState(item.expediente ? item.expediente : '')
    const [openModalExp, setOpenModalExp] = useState(false);
    const handleShow = (item) =>{
        //console.log(item)
        setObjDelete(item)
        setShowModalCancel(true)
    }

    const modalEditExp = () => setOpenModalExp(true)

    return(
        <Card className="shadow-1 mb-2">
            <Card.Body className="p-0">
                <div className="px-3 pt-3">
                    <div className="position-relative">
                        {(item.appointmentStatus!=="Cancelada" && item.appointmentStatus!=="Pendiente") && 
                            <ul className="list-unstyled card-actions">
                                {!item.patientDTO.currentInsurance && 
                                    <li>
                                        <OverlayTrigger
                                            key='top'
                                            placement='top'
                                            overlay={
                                                <Tooltip id={`tooltip-${item.id}`}>
                                                    Renovar poliza
                                                </Tooltip>
                                            }
                                            >
                                                <FaInfoCircle className="text-secondary"/>
                                            </OverlayTrigger>
                                    </li>
                                }
                                {(imPaciente && item.patientDTO.currentInsurance) && <li><Link to={`/admin/enconferencia/${item.id}`}><FaRegEye className="text-secondary"/></Link></li>}
                                {/* <li><AiOutlineFileDone className="color-C1C1C1"/></li> */}
                                {trash && <li><HiOutlineTrash className="color-red" onClick={e=>handleShow(item)}/></li>}
                                {(isAdminDoctor(auth.data.role) || isOperator(auth.data.role)) && <li><Link to={`/admin/detalle-cita/${item.id}`}><AiOutlineFolderView className="text-secondary"/></Link></li>}
                            </ul>
                        }
                    </div>
                    <Row>
                        <Col className="d-none d-md-block text-center" md="4">
                            <Row>
                                <Col xs="12" md="12">
                                    <Image src={item.scheduleDTO.doctor.url_photo ? item.scheduleDTO.doctor.url_photo : userDefault} fluid className="img-card-citas"/>
                                </Col>
                                <Col xs="12" md="12">
                                {(trash && item.appointmentStatus!=="Cancelada" && item.appointmentStatus!=="Pendiente") ? 
                                    <Link to={`/admin/proveedor/editar-cita/${item.id}/${item.scheduleDTO.doctor.id}/${item.patientDTO.id}`}>
                                        <FaPen className='colorNaranja clicked' />
                                    </Link>:
                                    <FaPen className='text-light' />
                                }
                                </Col>
                            </Row>
                            
                            
                        </Col>
                        <Col xs="12" md="8">
                            <div className="name-doctor">
                                <label className="d-block text-blue-2 text-center font-weight-bold mb-0 lh-1">Dr. {item.scheduleDTO.name_doctor}</label>
                                {
                                    item.account &&
                                    <small className="d-block text-center text-secondary font-weight-bold font-size-09rem">{`Cuenta: ${item.account?.name}`}</small>
                                }
                                <small className="d-block text-center text-secondary font-weight-bold-600 mt-1">{item.speciality.name}</small>
                                {item.expediente && 
                                    <small className="d-block text-center text-secondary font-size-08rem mt-2">{`No. expediente: ${expediente}`} {' '}
                                    {(isAdminDoctor(auth.data.role)|| isOperator(auth.data.role)) && <FaEdit className="mb-1" onClick={modalEditExp}/>}</small>
                                }
                                <span className="text-center d-block"><Stars stars={item.scheduleDTO.doctor.ranking} /></span>
                            </div>                            
                        </Col>

                        <Col xs="12" md="12">
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                    <div className="pe-2 pb-2">
                                        {item.appointmentStatus==='Pagada' && item.link && (isAdminDoctor(auth.data.role) || isOperator(auth.data.role)) &&
                                            <EnviarLinkCita item={item} auth={auth}/>
                                        }
                                    </div>
                                    <div className="pe-2 pb-2">
                                        {item.appointmentStatus!=='Fallida' && <div><EnviarDocumentos id={item.id} auth={auth}/></div>}
                                    </div>
                                    <div className="pe-2 pb-2">
                                        <div className={item.appointmentStatus==='Fallida' ? 'm-auto' : ''}>
                                            <DescargarDocumentos 
                                                id={item.id} 
                                                auth={auth}
                                                appoinmentStatus={item.appointmentStatus}
                                            />
                                        </div>  
                                    </div>
                                </div>
                        </Col>
                    </Row>   
                    <Row className="mt-1">
                        <Col xs="12" md={{span: 8, offset: 4}}>
                            <ul className="list-unstyled mb-0 text-secondary font-weight-bold-600 font-size-07rem">
                                <li>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <BsCalendar className="mb-1"/> {moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMM YYYY")}
                                        </div>
                                        <div>
                                            <FaRegClock /> {moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")}
                                        </div>
                                    </div>
                                    
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </div>                            
                <hr className="mt-2 mb-0"/>
                {
                    item.appointmentStatus==='Fallida' ? 
                    <div className="d-flex justify-content-center p-2">
                        <div><span className={`font-size-08rem font-weight-bold-600 text-fallida`}><IoCloseCircle className="mb-03rem"/> Fallida</span></div>
                    </div>: 
                    <div className="d-flex flex-md-row flex-column justify-content-center justify-content-md-between p-2 align-items-center">
                        <div><span className={`font-size-08rem font-weight-bold-600 ${item.appointmentStatus==='Pendiente' ? 'color-yellow' : 'color-C1C1C1'}`}><BsClockFill className="mb-03rem"/> {t('pendiente')}</span></div>
                        <div><span className={`font-size-08rem font-weight-bold-600 ${item.appointmentStatus==='Pagada' ? 'color-green' : 'color-C1C1C1'}`}><BiDollarCircle className="mb-03rem"/> {t('pagada')}</span></div>
                        <div><span className={`font-size-08rem font-weight-bold-600 ${item.appointmentStatus==='Cancelada' ? 'color-red' : 'color-C1C1C1'}`}><IoCloseCircle className="mb-03rem"/> {t('cancelada')}</span></div>
                    </div>
                }
            </Card.Body>

            <ModalChangeExpediente 
                openModalExp={openModalExp}
                setOpenModalExp={setOpenModalExp}
                idAppointment={item.id}
                expediente={expediente}
                setExpediente={setExpediente}
            />
        </Card>
    )
}

export default withTranslation()(CardCitas)